export const SET_HEADER_VALUE = "set_header_values";
export const SET_DOX_COINS = "set_dox_coins";